import { Files } from '../../lib/constants/files'
import { FileInput } from '../../lib/types/models/file/file-input'
import { HostFamily } from '../../lib/types/models/host-family/host-family'
import { HostFamilyRequest } from '../../lib/types/models/host-family/host-family-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateHostFamily(data: UpdateInput<HostFamilyRequest>) {
  const { id, picturesAndVideos, ...rest } = data
  let uploadedFiles: FileInput[] = []
  if (picturesAndVideos?.length) {
    uploadedFiles = (await Promise.all(
      picturesAndVideos.map((file) => (file ? uploadFile(Files.CENTER_EVENT_ACTION, file) : null))
    ).then((files) => files.filter((file) => file !== null))) as FileInput[]
  }
  return restApiClient
    .url(constructApiUrl(API.hostFamilies.update.url, { id }))
    .patch<HostFamily, Partial<HostFamilyRequest>>({ ...rest, picturesAndVideos: uploadedFiles })
}
